/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The order side is either buy or sell.
 * @export
 */
export const TradeSide = {
    BUY: 'buy',
    SELL: 'sell'
} as const;
export type TradeSide = typeof TradeSide[keyof typeof TradeSide];


export function instanceOfTradeSide(value: any): boolean {
    for (const key in TradeSide) {
        if (Object.prototype.hasOwnProperty.call(TradeSide, key)) {
            if (TradeSide[key as keyof typeof TradeSide] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TradeSideFromJSON(json: any): TradeSide {
    return TradeSideFromJSONTyped(json, false);
}

export function TradeSideFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeSide {
    return json as TradeSide;
}

export function TradeSideToJSON(value?: TradeSide | null): any {
    return value as any;
}

export function TradeSideToJSONTyped(value: any, ignoreDiscriminator: boolean): TradeSide {
    return value as TradeSide;
}

